import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Col, Row } from "react-bootstrap";
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();
AOS.refreshHard();


function Github() {
  return (
    <>
      <Row
        style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
          Days I Code
        </h1>
        <GitHubCalendar
          username="Ravi-047"
          blockSize={15}
          blockMargin={5}
          color="#ffd600"
          fontSize={16}
          style={{ cursor: "pointer" }}
        />

      </Row>
      <Row
        className="gitHubTrophies" >
        <img src="https://github-profile-trophy.vercel.app/?username=Ravi-047&theme=radical&no-frame=false&no-bg=false&margin-w=2" alt="github" style={{ cursor: "pointer" }} />
      </Row>

      <Row className="gitHubTrophies" style={{ cursor: "pointer" }}  >
        <Col md={6} style={{ paddingBottom: "20px" }}>
          <img src="https://github-readme-stats.vercel.app/api?username=Ravi-047&theme=radical&hide_border=true&include_all_commits=true&count_private=true" width="93%" alt="stats" style={{ border: "2px solid white", background: "#141321", borderRadius: "10px" }} />
        </Col>

        <Col className="codeTrophy" md={6}>
          <img src="https://github-readme-stats.vercel.app/api/top-langs/?username=Ravi-047&theme=radical&hide_border=true&include_all_commits=true&count_private=true&layout=compact" width="100%" alt="stats" style={{ border: "2px solid white", background: "#141321", borderRadius: "10px" }} />
        </Col>

      </Row>

      <Row className="gitHubTrophies" style={{ width: "fit-content" }} >
        <img align="center" src="https://github-readme-streak-stats.herokuapp.com/?user=Ravi-047&theme=radical&hide_border=true" alt="stats" style={{ border: "2px solid white", background: "#141321", borderRadius: "10px" }} />
      </Row>
    </>
  );
}

export default Github;
